<template>
  <div>
    <BaseTitle :title="$t(isEditable ? 'content.view_syllabus' : edit ? 'content.edit_syllabus' : 'content.add_syllabus')" :yearPeriode="titleData" />

    <form @submit.prevent="submit">
      <v-row>
        <v-col cols="12" md="6">
          <v-card class="mb-8">
            <div class="pa-8">
              <form-group :name="$t('form.status')" :validator="$v.form.status">
                <template slot-scope="{ attrs }">
                  <v-select
                    v-model="form.status"
                    v-bind="attrs"
                    :disabled="isEditable"
                    @input="$v.form.status.$touch()"
                    @blur="$v.form.status.$touch()"
                    :label="$t('form.status')"
                    :items="lockItems"
                  />
                </template>
              </form-group>
              <form-group :name="$t('content.class_title')" :validator="$v.form.classroomId">
                <template slot-scope="{ attrs }">
                  <v-select
                    v-model="form.classroomId"
                    :disabled="isEditable"
                    v-bind="attrs"
                    item-value="classroomId"
                    item-text="classroomName"
                    :items="classroomCourse"
                    :label="$t('content.class_title')"
                    @input="$v.form.classroomId.$touch()"
                    @blur="$v.form.classroomId.$touch()"
                    @change="getCourse"
                  >
                  </v-select>
                </template>
              </form-group>
              <form-group :name="$t('content.subject')" :validator="$v.form.courseId">
                <template slot-scope="{ attrs }">
                  <v-select
                    v-model="form.courseId"
                    v-bind="attrs"
                    item-value="courseId"
                    item-text="courseName"
                    :items="temporaryClassroomCourse"
                    :disabled="isEditable"
                    @input="$v.form.courseId.$touch()"
                    @blur="$v.form.courseId.$touch()"
                    :label="$t('content.subject')"
                  />
                </template>
              </form-group>
            </div>
          </v-card>
        </v-col>
        <v-col cols="12" md="6">
          <v-card class="mb-8">
            <div class="pa-8">
              <form-group :name="$t('form.schoolyear')" :validator="$v.form.schoolYear">
                <template slot-scope="{ attrs }">
                  <v-text-field
                    v-model="form.schoolYear"
                    :disabled="isEditable"
                    v-bind="attrs"
                    :label="$t('form.schoolyear')"
                    @input="$v.form.schoolYear.$touch()"
                    @blur="$v.form.schoolYear.$touch()"
                  />
                </template>
              </form-group>
              <!-- <form-group :name="$t('content.education_level')" :validator="$v.form.educationalLevel">
                <template slot-scope="{ attrs }">
                  <v-text-field
                    v-model="form.educationalLevel"
                    :disabled="isEditable"
                    v-bind="attrs"
                    :label="$t('content.education_level')"
                    @input="$v.form.educationalLevel.$touch()"
                    @blur="$v.form.educationalLevel.$touch()"
                  />
                </template>
              </form-group> -->
              <div class="app-section-title">{{ $t('content.syllabus') }}</div>
              <v-radio-group row v-model="form.text" :disabled="isEditable">
                <v-radio color="secondary" :label="$t('content.manual_input')" :value="true" />
                <v-radio color="secondary" :label="$t('content.upload_attach')" :value="false" />
              </v-radio-group>
            </div>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="12">
          <v-card class="mb-8">
            <div class="pa-8">
              <div v-if="form.text === true">
                <div class="app-section-title mb-5">{{ $t('content.tata_letak') }}</div>
                <v-radio-group row v-model="form.potrait">
                  <v-radio color="secondary" :label="$t('content.potrait')" :value="true" />
                  <v-radio color="secondary" :label="$t('content.landscape')" :value="false" />
                </v-radio-group>
                <form-group>
                  <template slot-scope="{ attrs }">
                    <text-editor v-bind="attrs" v-model="form.syllabus" :disabled="isEditable" />
                  </template>
                </form-group>
                <div v-if="form.syllabus" class="app-section-title mb-5">{{ $t('content.preview') }}</div>
                <div v-if="form.syllabus && form.potrait" style="border: 1px solid #d8d8d8;border-radius: 8px 8px 8px 8px;" class="pa-5">
                  <article v-if="form.syllabus" v-html="form.syllabus" />
                  <span v-else>-</span>
                </div>
                <div v-if="form.syllabus && !form.potrait" class="move-list-content pa-10 " style="overflow-x: auto;">
                  <ul>
                    <li>
                      <article v-if="form.syllabus" class="container mb-5" v-html="form.syllabus" />
                      <span v-else>-</span>
                    </li>
                  </ul>
                </div>
              </div>
              <form-group v-if="form.text === false" :name="$t('form.file')" :validator="$v.form.file" no-gutter>
                <template slot-scope="{ attrs }">
                  <v-file-input
                    :disabled="!form.syllabus && !form.text && edit"
                    :label="$t('form.file')"
                    accept=".pdf,.sb3"
                    chips
                    show-size
                    v-bind="attrs"
                    small-chips
                    v-model="form.file"
                    truncate-length="15"
                    @input="$v.form.file.$touch()"
                    @blur="$v.form.file.$touch()"
                  ></v-file-input>
                </template>
              </form-group>
              <div v-if="form.fileUrl && form.text === false">
                <!-- File Viewer -->
                <file-viewer :data="preview" v-model="dialogPreview" @onHide="hidePreview" />
                <a href="javascript:(0)" @click.prevent="previewFileTeacher(undefined, { fileList })"
                  >{{ fileList.fileName }}.{{ fileList.extension }}</a
                >
              </div>
            </div>
          </v-card>
          <div class="d-flex justify-end align-center">
            <v-btn color="primary" class="btn-primary-custom mr-3" outlined @click="back">{{ $t('cancel') }}</v-btn>
            <v-btn color="primary" class="btn-primary-custom" @click="submit" v-if="!isEditable" :loading="loading">
              {{ $t('submit') }}
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </form>
  </div>
</template>

<script>
import BaseTitle from '@/components/base/Title';
import { required } from 'vuelidate/lib/validators';
import { fileSize, fileType } from '@/validators';
import { mapGetters } from 'vuex';
import FileViewer from '@/components/FileViewer';
import TextEditor from '@/components/base/TextEditor.vue';
const extAllowed = ['pdf', 'sb3'];

export default {
  name: 'CreateEditSyllabus',
  components: {
    BaseTitle,
    FileViewer,
    TextEditor
  },
  props: {
    isClass: {
      type: Boolean,
      default: false
    },
    isEditable: {
      type: Boolean,
      default: false
    }
  },
  validations() {
    return {
      form: {
        courseId: { required },
        classroomId: { required },
        status: { required },
        schoolYear: { required },
        syllabus: this.form.text === true ? '' : '',
        // educationalLevel: { required },
        file:
          this.form.text === false && !this.form.fileUrl
            ? {
                required,
                fileSize: fileSize(500),
                fileType: fileType(extAllowed)
              }
            : { fileSize: fileSize(500), fileType: fileType(extAllowed) }
      }
    };
  },
  computed: {
    ...mapGetters({
      classLevel: 'QuizTeacher/classLevel',
      classTeacher: 'Class/items',
      tokenBearer: 'Auth/token'
    }),
    lockItems() {
      return [
        { text: this.$t('paginate.show'), value: true },
        { text: this.$t('content.hide'), value: false }
      ];
    }
  },
  data: () => ({
    form: {
      courseId: '',
      classroomId: '',
      status: '',
      // educationalLevel: '',
      schoolYear: '',
      fileName: null,
      file: null,
      syllabus: '',
      text: true,
      fileUrl: '',
      potrait: true
    },
    edit: false,
    classroomCourse: [],
    temporaryClassroomCourse: [],
    listCourse: [],
    loadingButton: false,
    dataClass: '',
    loading: false,
    dialogPreview: false,
    preview: {},
    fileList: {},
    previewDatas: '',
    titleData: ''
  }),
  methods: {
    getData() {
      this.$store.dispatch('Syllabus/fetchDetail', this.$route.params.id).then(ras => {
        this.fileList = ras;
        Object.keys(this.form).forEach(form => {
          this.form[form] = ras[form];
        });
        if (this.$route.params.id) {
          this.$store.dispatch('Class/fetchListClassroomCourseDetail', this.$route.params.id).then(res => {
            const datas = res.find(course => course.classroomId === ras.classroomId);
            this.temporaryClassroomCourse = datas.courses;
          });
        }
      });
    },
    getDataClassroomCOurse() {
      this.loading = true;
      this.$store
        .dispatch('Class/fetchListClassroomCourse')
        .then(res => {
          const datas = res.find(course => course.classroomId === this.form.classroomId);
          this.temporaryClassroomCourse = datas;
          this.classroomCourse = res;
        })
        .finally(() => {
          if (localStorage.getItem('backSyllabus') && !this.$route.params.id) {
            setTimeout(() => {
              this.getCourse();
            }, 200);
          }
          this.loading = false;
        });
    },
    getCourse() {
      const datas = this.classroomCourse.find(course => course.classroomId === this.form.classroomId);
      this.temporaryClassroomCourse = datas.courses;
    },
    getDataGradeId() {
      this.loading = true;
      this.$store
        .dispatch('QuizTeacher/fetchListGradeId', { classId: this.$route.params.classId, courseId: this.$route.params.courseId })
        .then(res => {
          this.form.gradeId = res.gradeId;
        })
        .finally(() => (this.loading = false));
    },
    getDataClass() {
      if (!this.$route.params.classSectionId) {
        this.$store
          .dispatch('Class/fetchClassroomCourseName', { classId: this.$route.params.classId, courseId: this.$route.params.courseId })
          .then(res => {
            if (this.user.cerdasTypeId === 2 || this.user.cerdasTypeId === null) {
              this.$store.dispatch('SchoolClass/fetchDetail', this.$route.params.classId).then(resa => {
                this.dataClass = resa;
                this.titleData = res + ` ( ${resa.yearPeriode} ) `;
              });
            } else {
              this.$store.dispatch('Class/fetchListLiteDetail', this.$route.params.classId).then(resa => {
                this.dataClass = resa;
                this.titleData = res + ` ( ${resa.yearPeriode} ) `;
              });
            }
          });
      } else {
        this.$store.dispatch('ClassSection/getListDetail', { classSectionId: this.$route.params.classSectionId }).then(res => {
          if (this.user.cerdasTypeId === 2 || this.user.cerdasTypeId === null) {
            this.$store.dispatch('SchoolClass/fetchDetail', this.$route.params.classId).then(resa => {
              this.dataClass = resa;
              this.titleData = res.classroomName + ` ${res.numberClass}` + ` ( ${resa.yearPeriode} ) `;
            });
          }
        });
      }
    },
    getClassLevel() {
      this.$store.dispatch('QuizTeacher/fetchClassLevelOrCourse');
    },
    submit() {
      const hasSyllabus = !!this.form.syllabus;
      const isText = this.form.text === true;
      const hasFile = !!this.form.file;
      const isEdit = this.edit === true;
      const validTextSubmission = isText && !hasFile;
      const validFileSubmission = !isText && (hasFile || isEdit);
      const canSubmit = validTextSubmission || validFileSubmission;

      this.$v.$touch();

      if (!hasSyllabus && isText) {
        this.$store.dispatch('general/showErrorNotification', { message: 'Description Required' });
        return;
      }

      if (this.$v.$invalid) return false;

      if (canSubmit) {
        this.loading = true;

        const payload = {
          ...(isEdit ? { id: this.$route.params.id } : null),
          ...this.form
        };

        this.$store
          .dispatch(`Syllabus/${isEdit ? 'update' : 'save'}`, payload)
          .then(() =>
            this.$router.push({
              name: isEdit ? 'SyllabusTeacherUpdateSuccess' : 'SyllabusTeacherSuccess'
            })
          )
          .finally(() => {
            localStorage.removeItem('backSyllabus');
            localStorage.removeItem('dataSyllabus');
            this.loading = false;
          });
      }
    },
    back() {
      let backuser = localStorage.getItem('backSyllabus');
      if (backuser) {
        localStorage.removeItem('backSyllabus');
        localStorage.removeItem('dataSyllabus');
        this.$router.back();
      } else {
        localStorage.removeItem('backSyllabus');
        localStorage.removeItem('dataSyllabus');
        this.$router.push({ name: 'SyllabusIndex' });
      }
    },
    // File Viewer Teacher
    previewFileTeacher(e, { fileList }) {
      this.dialogPreview = true;
      this.$set(this, 'preview', fileList);
    },
    hidePreview() {
      this.dialogPreview = null;
      this.$set(this, 'preview', {});
    }
  },
  created() {
    if (localStorage.getItem('backSyllabus') && !this.$route.params.id) {
      let data = JSON.parse(localStorage.getItem('dataSyllabus'));
      this.form.courseId = parseInt(data.courseId);
      this.form.classroomId = parseInt(data.classId);
      this.form.schoolYear = data.yearPeriode;
    }

    this.getDataClassroomCOurse();
    if (this.$route.params.id) {
      this.getData();
      this.edit = true;
    }
    if (this.isClass) {
      this.getDataGradeId();
      this.getDataClass();
    } else {
      this.getClassLevel();
      localStorage.removeItem('courseName');
    }
  }
};
</script>

<style lang="scss">
html,
body {
  height: 100%;
}

body {
  height: 100%;
}
.move-list {
  height: 100%;

  &-title {
    background: #00bf63;
    color: #fff;
    font-family: Montserrat;
    font-weight: 800;
    border-radius: 8px 8px 0 0;
    padding: 10px;
    width: 100%;
  }

  &-content {
    border: 1px solid #d8d8d8;
    border-radius: 0 0 8px 8px;
    padding: 10px;
    background: #fff;
    overflow: scroll;
    overflow-x: hidden;
    width: 100%;
    height: 100%;
    line-height: 2em;

    ul {
      list-style: none;
      padding: 0;

      li {
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid #d8d8d8;
        padding: 10px 15px;
        align-items: center;

        &:last-child {
          border-bottom: none;
        }
      }
    }
  }
}
.class2 thead tr th,
.class2 tbody tr td {
  border: 0.1px solid;
}
</style>
